
enum SetImagePartsCase {
    Image = 'image',
    ImageHover = 'image-hover',
    ImageMeta = 'image-meta'
}

export default SetImagePartsCase;